<template>
  <div></div>
</template>

<script>
export default {
  props: {
    loading_ok: {
      type: Boolean,
      default: true,
    },
  },

  created() {
    const loading = this.$loading({
      lock: true,
      text: "正在加载中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    setInterval(() => {
      if (this.loading_ok != true) {
        loading.close();
      }
    }, 200);
  },
};
</script>

<style></style>
